export default __webpack_public_path__ + "static/bg_app-0c7f34046b788dc5063ba1c2734767c8.webp";